import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'as-app-button-toggle',
  templateUrl: './button-toggle.component.html',
  styleUrl: './button-toggle.component.scss',
  standalone: false,
})
export class ButtonToggleComponent {
  @Output() languageSelect = new EventEmitter<any>();

  @Input() lang: string;

  @Input() languages: any;

  onLanguageSelect(event) {
    console.log(event);
    this.languageSelect.emit(event);
    // this.lang = event.toUpperCase()
  }
}
